<template>
    <div class="order-list">
        <ul v-if="list.length > 0">
            <li
                v-for="item in list" :key="item.orderNo">
                <div class="o-header">
                    <span>{{item.douBe}}
                        <i>快币</i>
                    </span>
                    <span>{{item.chargeType}}</span>
                </div>
                <div class="o-body">
                    <p><label for="">充值账号：</label><span>{{item.chargeAccount}}</span></p>
                    <p><label for="">付款金额：</label><span>{{item.amount}}元</span></p>
                    <p><label for="">付款时间：</label><span>{{item.completedTime}}</span></p>
                </div>
                <div class="o-footer">
                    <span @click="callMe(item)">联系客服</span>
                    <span @click="toComp(item)">发起投诉</span>
                </div>
            </li>
        </ul>
        <p class="tips" v-else>暂无订单记录</p>
        <p class="tips" >只显示最近7天的订单~</p>
    </div>
</template>
<script>
import {getUserOrder} from '@/api/api'
export default {
    data() {
        return {
            list: [],
            dy: 'https://work.weixin.qq.com/kfid/kfcea78c1f2408456ff',
            ks: 'https://work.weixin.qq.com/kfid/kfca566a24a3bebe142',
            routeObj: {}
        }
    },
    created() {
        this.routeObj = this.$route.query;
        console.log(this.routeObj);
        this.userCode = localStorage.getItem('userCode') || '';
        this.getOrderList();
    },
    methods: {
        callMe(item) {
            window.location.href = [20, 21].includes(Number(item.orderType)) ? this.ks : this.dy;
        },
        toComp(item) {
            this.$router.push({
                path: '/compChoose',
                query: {
                    orderNo: item.orderNo,
                }
            });
        },
        getOrderList() {
            getUserOrder({
                userCode: this.routeObj.extParam,
            }).then(res => {
                if(res.code === 200) {
                    this.list = res.data;
                }
                
            });
        },

    }
}
</script>
<style lang="less" scoped>
    .order-list {
        padding: 20px;
        .tips {
            color: #999;
            font-size: 16px;
            text-align: center;
            margin-bottom: 10px;
        }
        li {
            background-color: #fff;
            border-radius: 15px;
            box-shadow: 0 0 8px #ebedf0;
            font-size: 16px;
            margin-bottom: 20px;
            .o-header {
                padding: 0 20px;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px dashed #eee;
                font-size: 18px;
                span:last-child {
                    color: #999;
                }
            }
            .o-body {
                padding: 10px 20px;
                p {
                    height: 30px;
                    line-height: 30px;
                }
            }
            .o-footer {
                display: flex;
                height: 50px;
                line-height: 50px;
                font-size: 18px;
                span {
                    flex: 1;
                    text-align: center;
                    color: #fff;
                }
                span:first-child {
                    border-radius: 0 0 0 15px;
                    background-color: #ff9800;
                }
                span:last-child {
                    background-color: #ff5722;
                    border-radius: 0 0 15px 0;
                }
                span:active {
                    opacity: .9;
                }
            }
        }
    }
</style>